<div class="page-wide">
    <h1>FairBridge Privacy Policy</h1>

    <div class="content">
        <p>Data Practices &amp; Privacy Policy Statement (Updated August 2024)</p>
        <p>Safekeeping of your privacy is important to FairCloud Hospitality Systems Inc (&ldquo;FairCould PMS&rdquo;),
            including our affiliated network hotels. This Data Practices &amp; Privacy Policy Statement will provide
            information explaining our data management practices (in both an online and offline context) regarding the
            handling of personal data, and the policy information below provides further details on how we collect, use,
            disclose, secure, and retain your personal data.</p>
        <br />

        <div ngbAccordion>
            <div ngbAccordionItem>
                <h2 ngbAccordionHeader>
                    <button ngbAccordionButton>THE PERSONAL DATA WE COLLECT ABOUT YOU</button>
                </h2>
                <div ngbAccordionCollapse>
                    <div ngbAccordionBody>
                        <ng-template>
                            <p>&ldquo;Personal Data&rdquo; are data that identify you as an individual or relate to an
                                identifiable
                                individual.</p>
                            <p>We collect the following types of Personal Data in both an online and offline context,
                                when providing you
                                with our products and services:</p>
                            <p>Personal Data that we may collect from you:</p>
                            <ul>
                                <li>Name</li>
                                <li>Birthdate</li>
                                <li>Gender identification</li>
                                <li>Postal address</li>
                                <li>Billing address</li>
                                <li>Telephone number</li>
                                <li>Email address</li>
                                <li>Credit and debit card number or other payment data</li>
                                <li>Financial Information (in limited circumstances)</li>
                                <li>Language preference</li>
                                <li>Marital status</li>
                                <li>Nationality, passport, visa or other government-issued identification data</li>
                                <li>Important dates, such as anniversaries and special occasions</li>
                                <li>Travel itinerary, tour group or activity data</li>
                                <li>Prior guest stays, or interactions, goods and services purchased, special service
                                    and amenity requests
                                </li>
                                <li>Geolocation information</li>
                                <li>Social media account information, profile photo and other data publicly available
                                </li>
                            </ul>
                            <p>We may also collect the following types of personal data for the following purposes:</p>
                            <ul>
                                <li>Images and video and audio data via security cameras located in public areas, such
                                    as hallways and
                                    lobbies, on our properties</li>
                                <li>Guest preferences and personalized data such as your interests, activities, hobbies,
                                    food and beverage
                                    choices, services and amenities of which you advise us or which we learn about
                                    during your visit</li>
                            </ul>
                            <p>Personal Data that We Automatically Collect</p>
                            <p>We may use tracking technologies, such as cookies, pixels, and web beacons to collect the
                                following
                                information:</p>
                            <ul>
                                <li>IP Address</li>
                                <li>Location/Geolocation</li>
                                <li>Media Access Control (MAC) address</li>
                                <li>Unique device identifier (UDID/IMEI)</li>
                                <li>Operating system or platform</li>
                                <li>Screen resolution</li>
                                <li>Operating system name and version</li>
                                <li>Device manufacturer and model</li>
                                <li>Language preferences</li>
                                <li>Internet browser type and version</li>
                                <li>Name and version of the Online Services (such as the Apps) you are using</li>
                                <li>Browser type</li>
                                <li>Time spent on the Online Services</li>
                                <li>Pages visited</li>
                                <li>Referring URL</li>
                                <li>Duration of visit to our website</li>
                                <li>Links you click on in our emails and on our website, including ads</li>
                            </ul>
                        </ng-template>
                    </div>
                </div>
            </div>
            <div ngbAccordionItem>
                <h2 ngbAccordionHeader>
                    <button ngbAccordionButton>CHANGES TO YOUR PERSONAL DATA</button>
                </h2>
                <div ngbAccordionCollapse>
                    <div ngbAccordionBody>
                        <ng-template>
                            <p>It is important that the Personal Data we hold about you is accurate and up-to-date.
                                Please
                                keep us informed
                                if your Personal Data changes during your relationship with us. You can do so by sharing
                                updates or
                                corrections with us at&nbsp;privacy&#64;fairbridgeinns.com</p>
                        </ng-template>
                    </div>
                </div>
            </div>
            <div ngbAccordionItem>
                <h2 ngbAccordionHeader>
                    <button ngbAccordionButton>HOW WE COLLECT YOUR PERSONAL DATA</button>
                </h2>
                <div ngbAccordionCollapse>
                    <div ngbAccordionBody>
                        <ng-template>
                            <p>Personal Data collection is obtained in a variety of ways:</p>
                            <ul>
                                <li>Online Services. Personal Data is collected through online services either directly
                                    or through an
                                    affiliate booking website.</li>
                                <li>Reservation Process</li>
                                <li>Check out process for electronic folio receipts</li>
                                <li>Purchase goods or services through the website or e-commerce website</li>
                                <li>Communication via email</li>
                                <li>Connect or post to social media related to the properties</li>
                                <li>Participation in a survey, contest or promotional offer</li>
                                <li>Property Visits. Personal Data is collected when guests visit our properties or use
                                    on-property services
                                    and outlets, such as Food Outlets, Concierge Services, Spa Facilities</li>
                                <li>Offline Interactions. Personal Data is collected when individuals attend promotional
                                    events that we host
                                    or in which we participate, or when you provide your Personal Data to facilitate an
                                    event.</li>
                                <li>Reservations Support and Customer Service Centers. Personal Data is collected when
                                    you make a
                                    reservation over the phone or communicate with us by email, mobile app, social
                                    media, or contact
                                    customer service. These communications may be recorded for purposes of quality
                                    assurance and training.
                                </li>
                                <li>Other Sources. Personal Data is also collected from other sources, such as public
                                    databases, joint
                                    marketing partners and other third parties.</li>
                                <li>Internet-Connected Devices. Personal Data is collected from internet-connected
                                    devices available in our
                                    properties. For example, a smart assistant device may be available for your use and
                                    to tailor your
                                    accommodations and experience.<br />We collect automatically-collected data in a
                                    variety of ways:</li>
                                <li>Your browser or network device. We collect certain data through your browser or
                                    automatically through
                                    your device. We use this data to ensure that the Online Services function properly.
                                </li>
                                <li>Cookies. We collect certain data from cookies, which are pieces of data stored
                                    directly on the computer
                                    or mobile device that you are using. Cookies allow us to collect data such as
                                    browser type, time spent
                                    on the Online Services, pages visited, referring URL, language preferences, and
                                    other aggregated traffic
                                    data. We use the data for security purposes, to facilitate navigation, to display
                                    data more effectively,
                                    to collect statistical data, to personalize your experience while using the Online
                                    Services, and to
                                    recognize your computer to assist your use of the Online Services. We also gather
                                    statistical data about
                                    use of the Online Services to continually improve design and functionality,
                                    understand how they are
                                    used, and assist us with resolving questions.</li>
                                <li>We collect analytical data through Google Analytics and Adobe Analytics, which use
                                    cookies and
                                    technologies to collect and analyze data about use of the Services. These services
                                    collect data
                                    regarding the use of other websites, apps and online resources. You can learn about
                                    Google&rsquo;s
                                    practices by going to www.google.com/policies/privacy/partners/, and opt out by
                                    downloading the Google
                                    Analytics opt-out browser add-on at: https://tools.google.com/dlpage/gaoptout. You
                                    can learn more about
                                    Adobe and opt out by visiting https://www.adobe.com/privacy/opt-out.html.</li>
                                <li>Pixel Tags and other similar technologies. We collect data from pixel tags (also
                                    known as web beacons
                                    and clear GIFs), which are used with some Online Services to, among other things,
                                    track the actions of
                                    users of the Online Services (including email recipients), measure the success of
                                    our marketing
                                    campaigns, and compile statistics about usage of the Online Services and Analytics.
                                </li>
                                <li>Aggregated Data. We may aggregate data that we have collected. This aggregated data
                                    will not personally
                                    identify you or any other user.</li>
                            </ul>
                        </ng-template>
                    </div>
                </div>
            </div>
            <div ngbAccordionItem>
                <h2 ngbAccordionHeader>
                    <button ngbAccordionButton>HOW WE USE YOUR PERSONAL DATA</button>
                </h2>
                <div ngbAccordionCollapse>
                    <div ngbAccordionBody>
                        <ng-template>
                            <p>We use Personal Data and Other Data to provide you with Services, to develop new
                                offerings, and to protect
                                FairBridge Hospitality Systems Inc, our affiliate partners, and our guests as detailed
                                below. In some
                                instances, we will request that you provide Personal Data or Other Data to us directly.
                                If you do not
                                provide the data that we request, or prohibit us from collecting such data, we may not
                                be able to provide
                                the requested Services. We will let you know if this is ever the case. We use Personal
                                Data and Other Data
                                for the following purposes:</p>
                            <ul>
                                <li>To provide services to you.</li>
                                <li>To provide services requested by you. For example, if you sign up for our
                                    newsletter, we will use the
                                    information you give us to send you our newsletter.</li>
                                <li>To provide our website and its functionalities to you.</li>
                                <li>To respond to your requests. If you contact us with a question or a request, we will
                                    use your
                                    information to respond to your request. For example, if you contact us via email
                                    with a question, we
                                    will use the information in that email and the email address you used to contact us
                                    to respond to you.
                                </li>
                                <li>To provide you with location-specific services. If you elect to share your location
                                    information with us,
                                    we may use that information to tailor options, functionality or offers related to
                                    your location. We also
                                    may use your IP address to determine your general location, which also may be used
                                    to tailor offers to
                                    you.</li>
                                <li>To offer and conduct promotions and contests.</li>
                                <li>To conduct data analytics to support our website and business. Typically, these
                                    analyses are done using
                                    aggregated or otherwise de-identified data. We use information, including
                                    automatically-collected
                                    information, to manage and improve our website and our business. For example, we use
                                    such information
                                    to:</li>
                            </ul>
                            <ol start="1">
                                <li>Manage our business needs, such as monitoring, analyzing, and improving the services
                                    and the
                                    website&rsquo;s performance and functionality. For example, we analyze website user
                                    behavior, and
                                    conduct research and analysis about the way you and other users use our website.
                                </li>
                                <li>Manage risk and protect the website. We use data to better protect our services, our
                                    website, and you by
                                    helping to detect and prevent fraud and abuse of the website and our services.</li>
                            </ol>
                            <ul>
                                <li>To tailor our offerings to your apparent interests.</li>
                                <li>To develop new products, services and offers.</li>
                                <li>To operate and improve our business.</li>
                                <li>To maintain our records.</li>
                                <li>To market to you. Information we collect about you and how you use and interact with
                                    the website and our
                                    services, ads, and other online content helps us to improve our website and offer
                                    additional products
                                    and services that we think might interest you. For example, we analyze information
                                    about user
                                    interactions with our marketing emails and online ads (such as whether emails have
                                    been opened or
                                    whether ads are clicked on) to determine whether those communications and ads are
                                    effective, and to
                                    understand what other website functionalities, products or services may interest
                                    you.</li>
                                <li>For legal, contractual and safety purposes. We will use your information as
                                    necessary to enforce the
                                    terms of our website, to comply with all applicable laws and regulations, to defend
                                    or protect us, our
                                    users, you, or third parties from harm or in legal proceedings, to protect our
                                    rights, to protect our
                                    security and the security of our users, employees, and property, to respond to court
                                    orders, lawsuits,
                                    subpoenas, and government requests, to address legal and regulatory compliance, to
                                    verify your identity
                                    or communications from you, to comply with contracts and other agreements to which
                                    we are a party, and
                                    to notify you of changes to our terms, policies, or practices.</li>
                                <li>To conduct internal monitoring and training.<br />For other purposes for which you
                                    provide your consent.
                                    We will use your information for other purposes which are disclosed to you at the
                                    time your information
                                    is collected or for purposes which can be inferred from or are obvious given the
                                    circumstances of
                                    collection. For example, if you give us your personal information when entering a
                                    contest, we will use
                                    that information to facilitate your participation in that contest.</li>
                            </ul>
                        </ng-template>
                    </div>
                </div>
            </div>
            <div ngbAccordionItem>
                <h2 ngbAccordionHeader>
                    <button ngbAccordionButton>DISCLOSURE OF YOUR PERSONAL DATA</button>
                </h2>
                <div ngbAccordionCollapse>
                    <div ngbAccordionBody>
                        <ng-template>
                            <p>Our goal is to provide you with the highest level of hospitality and Services, and to do
                                so, we share
                                Personal Data with the following:</p>
                            <ul>
                                <li>Site Operators and Licensees. We disclose Personal Data and Other Data for the
                                    purposes described in
                                    this Privacy Statement, such as providing and personalizing the Services.</li>
                                <li>Strategic Business Partners. We disclose Personal Data and Other Data with select
                                    Strategic Business
                                    Partners who provide goods, services and offers that enhance your experience at our
                                    properties or that
                                    we believe will be of interest to you. By sharing data with these Strategic Business
                                    Partners, we are
                                    able to make personalized services and unique travel experiences available to you.
                                    For example, this
                                    sharing enables spa, restaurant, health club, concierge and other outlets at our
                                    properties to provide
                                    you with services. This sharing also enables us to provide you with a single source
                                    for purchasing
                                    packages that include travel-related services, such as airline tickets, rental cars
                                    and vacation
                                    packages.</li>
                                <li>Service Providers. We disclose Personal Data and Other Data to third-party service
                                    providers for the
                                    purposes described in this Privacy Statement. Examples of service providers include
                                    companies that
                                    provide website hosting, data analysis, payment processing, order fulfillment,
                                    information technology
                                    and related infrastructure provision, customer service, email delivery, marketing,
                                    auditing and other
                                    services.</li>
                                <li>Corporate Reorganization. We may disclose or transfer your Personal Data and Other
                                    Data to a third party
                                    in the event of any reorganization, merger, sale, joint venture, assignment,
                                    transfer or other
                                    disposition of all or any portion of the FairBridge Hospitality Systems Inc, its
                                    affiliate businesses,
                                    assets or stock (including any bankruptcy or similar proceedings).</li>
                            </ul>
                            <p>We may disclose information that we collect or you provide as described in this privacy
                                policy for the
                                following purposes:</p>
                            <ul>
                                <li>To fulfill the purpose for which you provide it.</li>
                                <li>To comply with any court order, law or legal process, including to respond to any
                                    government or
                                    regulatory request.</li>
                                <li>To enforce or apply our Terms of Use and other agreements, including for billing and
                                    collection
                                    purposes.</li>
                                <li>If we believe disclosure is necessary or appropriate to protect the rights,
                                    property, or safety of our
                                    business, our customers, or others.</li>
                                <li>For any other purpose disclosed by us when you provide the information with your
                                    consent.</li>
                                <li>Other Disclosures. We will use and disclose Personal Data as we believe to be
                                    necessary or appropriate:
                                    (a) to comply with applicable law, including laws outside your country of residence;
                                    (b) to comply with
                                    legal process; (c) to respond to requests from public and government authorities,
                                    including authorities
                                    outside your country of residence and to meet national security or law enforcement
                                    requirements; (d) to
                                    enforce our terms and conditions; (e) to protect our operations; (f) to protect the
                                    rights, privacy,
                                    safety or property of FairCloud Hospitality Systems Inc, our affiliates, you, or
                                    others; and (g) to
                                    allow us to pursue available remedies or limit the damages that we may sustain.</li>
                            </ul>
                            <p>In some instances, we may combine de-identified or anonymized data with Personal Data
                                (such as combining your
                                name with your location). If we do, we will treat the combined data as Personal Data for
                                so long as it is
                                combined.</p>
                        </ng-template>
                    </div>
                </div>
            </div>
            <div ngbAccordionItem>
                <h2 ngbAccordionHeader>
                    <button ngbAccordionButton>YOUR CHOICES ON COLLECTION, USE AND SHARING OF YOUR PERSONAL
                        DATA</button>
                </h2>
                <div ngbAccordionCollapse>
                    <div ngbAccordionBody>
                        <ng-template>
                            <p>Information Collected from you</p>
                            <p>It is optional for you to provide us with information. Depending on the activity, some of
                                the information we
                                ask you to provide is identified as mandatory and some is identified as voluntary. If
                                you do not provide the
                                mandatory information for a particular activity that requires it, you will not be
                                permitted to engage in
                                that activity.</p>
                            <p>Emails</p>
                            <p>You can opt out of receiving future promotional email messages received directly from us
                                or by our authorized
                                service providers by following the opt-out instructions provided in any such message you
                                receive. Some of
                                our email communications may be transmitted on our behalf by our authorized service
                                providers. As such, the
                                opt-out language may differ depending upon the source, but generally states:
                                &ldquo;Click here to
                                unsubscribe from future emails.&rdquo; Click here if you wish to unsubscribe now. Please
                                note that it may
                                take up to ten (10) business days to process your request. Please also be aware that we
                                may continue to send
                                you transactional and administrative communications, such as emails confirming your
                                transactions with us,
                                and notices regarding changes to our Privacy Policy.</p>
                            <p>Cookies</p>
                            <p>We provide a variety of services on our website using cookies. We place cookies on your
                                device in order to
                                provide you with personalized access to essential services, enhance website
                                functionality, and to show you
                                offers and services tailored to your interests.</p>
                            <p>What is a Cookie?</p>
                            <p>A cookie is a small piece of data that a website can send to your browser, which may then
                                be stored on your
                                hard drive as a &ldquo;tag&rdquo; that identifies your computer. Cookies help to
                                navigate from page to page
                                on a website, provide secure connections, gather statistics about the usage and
                                effectiveness of our site,
                                and remember preferences from a previous visit when you return.</p>
                            <p>For example, we use Google Analytics to help us analyze how visitors use our websites and
                                mobile
                                applications. The information generated by the cookie, including your IP address, is
                                transmitted to Google.
                                This information is then used to evaluate visitors&rsquo; use of the website and mobile
                                applications and to
                                compile statistical reports on website activity for us. We do not use the statistical
                                analytics tool to
                                track visitors to our website and mobile applications. If you do not want any
                                information to be collected
                                and used by Google Analytics, you can install an opt-out in your web browser.</p>
                            <p>Cookie Choices</p>
                            <p>Most web browsers automatically accept cookies, but you can change your browser&rsquo;s
                                settings to disable
                                all or certain cookies if you wish. For more information on how to manage browser
                                cookies, see
                                https://www.allaboutcookies.org. Click on the links below to learn how to manage cookies
                                on these browsers:
                            </p>
                            <ul>
                                <li>GOOGLE CHROME</li>
                                <li>MICROSOFT EDGE</li>
                                <li>MOZILLA FIREFOX</li>
                                <li>MICROSOFT INTERNET EXPLORER</li>
                                <li>OPERA</li>
                                <li>APPLE SAFARI</li>
                            </ul>
                            <p>Please note that by disabling or deleting cookies, you may not be able to access the full
                                functionality of
                                our website. Disabling or clearing cookies also may affect cookie-based opt-outs by
                                either preventing you
                                from using such cookie-based opt-outs, or clearing opt-outs that you previously set. You
                                may control your
                                advertising preferences or opt out of certain Google advertising products by visiting
                                the Google Ads
                                Preferences Manager, currently available at https://google.com/ads/preferences, or by
                                visiting online
                                resources at https://www.networkadvertising.org/choices.</p>
                            <p>Some of the third parties that we may work with may participate in the Digital
                                Advertising Alliance&rsquo;s
                                (DAA) self-regulatory program, which provides consumers tools to opt-out of receiving
                                interest-based
                                advertising. Click here to learn more about the DAA&rsquo;s WebChoices tool. To help
                                control or block
                                certain ads in mobile applications, you may choose to download and utilize the DAA
                                mobile app by clicking
                                here.</p>
                            <p>You also can learn more about opting out of third parties&rsquo; use of cookies used to
                                tailor ads and other
                                content to you at https://www.networkadvertising.org/managing/opt_out.aspand
                                https://www.aboutads.info/choices.</p>
                        </ng-template>
                    </div>
                </div>
            </div>
            <div ngbAccordionItem>
                <h2 ngbAccordionHeader>
                    <button ngbAccordionButton>HOW WE KEEP YOUR PERSONAL DATA SECURE</button>
                </h2>
                <div ngbAccordionCollapse>
                    <div ngbAccordionBody>
                        <ng-template>
                            <p>We use appropriate organizational, technical and administrative measures to protect Personal Data.
                                Unfortunately, no data transmission or storage system can be guaranteed to be 100% secure. If you have
                                reason to believe that your interaction with us is no longer secure (for example, if you feel that the
                                security of your account has been compromised), please immediately notify us in accordance with the
                                &ldquo;Contact Us&rdquo; section on the website.</p>
                        </ng-template>
                    </div>
                </div>
            </div>
            <div ngbAccordionItem>
                <h2 ngbAccordionHeader>
                    <button ngbAccordionButton>HOW LONG WE RETAIN YOUR PERSONAL DATA</button>
                </h2>
                <div ngbAccordionCollapse>
                    <div ngbAccordionBody>
                        <ng-template>
                            <p>We will only retain your Personal Data for as long as necessary to fulfill the purposes we collected it for,
                                including for the purposes of satisfying any legal, accounting, or reporting requirements.</p>
                            <p>In specific circumstances, we may store your personal information for longer periods of time so that we have
                                an accurate record of your dealings with us in the event of any complaints or challenges, or if we
                                reasonably believe there is a prospect of litigation relating to your personal information or dealings.</p>
                        </ng-template>
                    </div>
                </div>
            </div>
            <div ngbAccordionItem>
                <h2 ngbAccordionHeader>
                    <button ngbAccordionButton>LINKS TO THIRD PARTY WEBSITES</button>
                </h2>
                <div ngbAccordionCollapse>
                    <div ngbAccordionBody>
                        <ng-template>
                            <p>This Privacy Policy addresses the use and disclosure of information we collect from you on our websites.
                                Other websites that may be accessible through this website have their own privacy policies and data
                                collection, use and disclosure practices. It may not always be apparent that you have gone to a third party
                                website. For example, if we have a link on our site to Trip Advisor. We are not responsible for the policies
                                or practices of third parties for which there are links on our website. If you click on a link to any such
                                website, we urge you to review the website&rsquo;s privacy policy.</p>
                        </ng-template>
                    </div>
                </div>
            </div>
            <div ngbAccordionItem>
                <h2 ngbAccordionHeader>
                    <button ngbAccordionButton>CHILDREN</button>
                </h2>
                <div ngbAccordionCollapse>
                    <div ngbAccordionBody>
                        <ng-template>
                            <p>Minors under the age of 18 may not use the Website. No part of the Website is designed to attract anyone
                                under the age of 18. However, we may collect information regarding children that stay in our hotels as
                                guests if information is provided by the parent or legal guardian. If you believe we have information about
                                your child and you would like it deleted from our system, please contact us at info&#64;fairbridgeinns.com.</p>
                        </ng-template>
                    </div>
                </div>
            </div>
            <div ngbAccordionItem>
                <h2 ngbAccordionHeader>
                    <button ngbAccordionButton>PUBLIC AREAS</button>
                </h2>
                <div ngbAccordionCollapse>
                    <div ngbAccordionBody>
                        <ng-template>
                            <p>We may provide areas on our website where you can publicly post information about yourself and communicate
                                with others, such as discussion boards or blogs. This information may be accessible by other consumers and
                                companies, and may appear on other websites or web searches; therefore, this information could be read,
                                collected, and used by others.</p>
                        </ng-template>
                    </div>
                </div>
            </div>
            <div ngbAccordionItem>
                <h2 ngbAccordionHeader>
                    <button ngbAccordionButton>FOR PERSONS WITHIN THE EUROPEAN UNION</button>
                </h2>
                <div ngbAccordionCollapse>
                    <div ngbAccordionBody>
                        <ng-template>
                            <p>Controller of Personal Data</p>
                            <p>For the purposes of applicable EU data protection laws, FairBridge Hospitality Systems Inc will be a data
                                controller of any Personal Data about you. If you have any questions regarding our use of your Personal Data
                                or this Privacy Policy, please contact Privacy&#64;fairbridgeinns.com.</p>
                            <p>How to contact us or make complaints</p>
                            <p>If you have any questions regarding our use of your personal data (including any requests to exercise your
                                legal rights) or this privacy policy, please contact info&#64;fairbridgeinns.com.</p>
                            <p>Our full contact details are:</p>
                            <p>FairCloud Hospitality Systems Inc</p>
                            <p>5976 West Las Positas Blvd Suite #230</p>
                            <p>Pleasanton, CA 94588</p>
                            <p>Attn: Data Privacy Department</p>
                            <p>You have the right to make a complaint at any time to the relevant supervisory authority in your country of
                                residence for data protection issues. We always appreciate the chance to deal with your concerns before you
                                approach the relevant supervisory authority, so please contact us in the first instance.</p>
                            <p>Individual Rights</p>
                            <p>You may have certain rights under European Union or Member State law or regulation. We have explained these
                                individual rights and controls below. To exercise these rights and controls, please contact us at
                                Privacy&#64;fairbridgeinns.com.</p>
                            <ul>
                                <li>Access: You may have the right to ask for a copy of the Personal Data that we hold about you.</li>
                                <li>Correction: If there are any inaccuracies in the information we hold about you, please contact us to
                                    correct them.</li>
                                <li>Deletion: If you would like us to delete your Personal Data, you may request that we delete it. Please
                                    note that this may not always be possible.</li>
                                <li>Restrictions on use: In certain circumstances, you may request that we stop processing your Personal
                                    Data.</li>
                                <li>Object: You may have the right to object to processing of your Personal Data.</li>
                                <li>Request the transfer: You may have the right to transfer your Personal Data to another organization</li>
                                <li>Withdrawal of consent: If you previously gave us your consent to allow us to process your Personal Data
                                    for a particular purpose, but you no longer wish to consent to us doing so, you can contact us to let us
                                    know that you withdraw that consent.</li>
                            </ul>
                            <p>Data Processing Activities and Legal Basis for Processing of Data</p>
                            <table>
                                <tbody>
                                    <tr>
                                        <td colspan="1" rowspan="1">
                                            <p>Processing Activity</p>
                                        </td>
                                        <td colspan="1" rowspan="1">
                                            <p>Legal Basis</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="1" rowspan="1">
                                            <p>Facilitate reservations and payment functions.</p>
                                        </td>
                                        <td colspan="1" rowspan="1">
                                            <p>Consent; Performance of a Contract</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="1" rowspan="1">
                                            <p>Support our electronic receipt program.</p>
                                        </td>
                                        <td colspan="1" rowspan="1">
                                            <p>Consent; Performance of a Contract.</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="1" rowspan="1">
                                            <p>Personalize the Services according to your Personal Preferences.</p>
                                        </td>
                                        <td colspan="1" rowspan="1">
                                            <p>Consent; Legitimate interests.</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="1" rowspan="1">
                                            <p>Marketing activities, including sweepstakes, activities, events and promotions.</p>
                                        </td>
                                        <td colspan="1" rowspan="1">
                                            <p>Consent; Legitimate interest.</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="1" rowspan="1">
                                            <p>Data analysis, audits, security and fraud monitoring and prevention.</p>
                                        </td>
                                        <td colspan="1" rowspan="1">
                                            <p>Legitimate interest.</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="1" rowspan="1">
                                            <p>Product and services development and enhancement research.</p>
                                        </td>
                                        <td colspan="1" rowspan="1">
                                            <p>Legitimate interest.</p>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <p>Transfer of Personal Data from the European Union</p>
                            <p>Our website is operated from and hosted on servers located in the United States. If you access and use our
                                website from a location outside of the United States, any personal data you provide to us or that is
                                otherwise collected may be transferred to and processed in the United States, or any other jurisdiction, in
                                our sole discretion. Users of our website should be aware that the laws that apply to the use and protection
                                of personal data in the United States or other countries or jurisdictions to which we transfer, or in which
                                we process, personal data may differ from those of your country of residence. Users who access or use our
                                website from jurisdictions outside of the United States do so at their own choice and risk, and are solely
                                responsible for compliance with local law. While we take steps to safeguard your personal data, the United
                                States has NOT been deemed by the European Commission to ensure an adequate level of protection for personal
                                data. Accordingly, the level of protection provided in the United States or other non-EU countries and
                                jurisdictions from which you may access our website may not be as stringent as that under EU data protection
                                standards or the data protection laws of some other countries, possibly including your home jurisdiction.
                            </p>
                        </ng-template>
                    </div>
                </div>
            </div>
            <div ngbAccordionItem>
                <h2 ngbAccordionHeader>
                    <button ngbAccordionButton>NOTICE OF PRIVACY RIGHTS TO CALIFORNIA RESIDENTS</button>
                </h2>
                <div ngbAccordionCollapse>
                    <div ngbAccordionBody>
                        <ng-template>
                            <p>Under California Civil Code Section 1798.83, individual customers who reside in California and who have an
                                existing business relationship with us may request information about our disclosure of certain categories of
                                personal information to third parties for the third parties&rsquo; direct marketing purposes, if any.</p>
                            <p>Your California Privacy Rights</p>
                            <p>By availing yourself of the rights afforded in this section of our Privacy Policy, you are declaring that you
                                are a California resident:</p>
                            <p>Other residents: You may make a verified request to us regarding your personal information. While we do not
                                sell your personal information, you can nonetheless make a formal request to delete your personal
                                information held by us. This process is detailed below, which also describes the designated address
                                information for making requests to us regarding your personal information.</p>
                            <p>The Right to Know Your Personal Data</p>
                            <p>You have the right to request that we disclose the personal information we collect, use, disclose and
                                &ldquo;sell&rdquo; about you. For more information on how to exercise this right, please see Section 6 of
                                our Privacy Policy. The following is a Summary of the categories of personal information we collected over
                                the past twelve (12) months:</p>
                            <table>
                                <tbody>
                                    <tr>
                                        <td colspan="1" rowspan="1">
                                            <p>Category of Personal Information</p>
                                        </td>
                                        <td colspan="1" rowspan="1">
                                            <p>Sources from which Personal Information was collected</p>
                                        </td>
                                        <td colspan="1" rowspan="1">
                                            <p>Purpose of collection</p>
                                        </td>
                                        <td colspan="1" rowspan="1">
                                            <p>Categories of entities with which Personal Information was shared</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="1" rowspan="1">
                                            <p>Address and other identifiers &ndash; such as name, postal address, email address, account
                                                name, Social Security number, driver&rsquo;s license number, passport number, or other
                                                similar identifiers.</p>
                                        </td>
                                        <td colspan="1" rowspan="1">
                                            <p>Automated collection on our Sites, services, products, applications, databases, devices,
                                                information systems and networks, and through cookies.</p>
                                            <p>Service providers, business partners, data brokers and other third-party contacts.</p>
                                            <p>Publicly available sources (e.g., Social Media)</p>
                                            <p>Government sources and records</p>
                                        </td>
                                        <td colspan="1" rowspan="1">
                                            <p>To provide the Proper platform and related services</p>
                                            <p>Business Operations</p>
                                            <p>Marketing</p>
                                            <p>Cybersecurity, fraud prevention and other security purposes</p>
                                            <p>Personnel Services</p>
                                            <p>Personnel Administration</p>
                                            <p>Regulatory and Legal</p>
                                        </td>
                                        <td colspan="1" rowspan="1">
                                            <p>Service Providers</p>
                                            <p>Government entities</p>
                                            <p>Third parties pursuant to lawful process</p>
                                            <p>Third parties to whom you have intentionally interacted with (e.g., potential recruiting
                                                services on our site)</p>
                                            <p>Other Proper members and service customers</p>
                                            <p>Third party advertisers and analytics providers</p>
                                            <p>Affiliates and other business partners</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="1" rowspan="1">
                                            <p>Unique and online identifiers &ndash; such as IP address, device IDs, or other similar
                                                identifiers</p>
                                        </td>
                                        <td colspan="1" rowspan="1">
                                            <p>Automated collection on our Sites, services, products, applications, databases, devices,
                                                information systems and networks, and through cookies</p>
                                            <p>Service providers, business partners, and other third party contacts</p>
                                            <p>Publicly available sources (e.g., Social Media)</p>
                                        </td>
                                        <td colspan="1" rowspan="1">
                                            <p>To provide the Proper platform and related services</p>
                                            <p>Business Operations</p>
                                            <p>Marketing</p>
                                            <p>Cybersecurity, fraud prevention and other security purposes</p>
                                            <p>Personnel Services</p>
                                            <p>Personnel Administration</p>
                                            <p>Regulatory and Legal</p>
                                            <p>To provide the Proper platform and related recruiting services</p>
                                            <p>Business Operations</p>
                                            <p>Marketing</p>
                                            <p>Cybersecurity, fraud prevention and other security purposes</p>
                                            <p>Regulatory and Legal</p>
                                        </td>
                                        <td colspan="1" rowspan="1">
                                            <p>Service Providers</p>
                                            <p>Government entities</p>
                                            <p>Third parties pursuant to lawful process</p>
                                            <p>Other Proper members and service customers</p>
                                            <p>Third party advertisers and analytics providers</p>
                                            <p>Affiliates and other business partners</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="1" rowspan="1">
                                            <p>Inferences drawn from CCPA PI &ndash; such as individual profiles, preferences,
                                                characteristics, behaviors</p>
                                        </td>
                                        <td colspan="1" rowspan="1">
                                            <p>Automated collection on our Sites, services, products, applications, databases, devices,
                                                information systems and networks, and through cookies</p>
                                            <p>Service providers, business partners, data brokers and other third-party contacts</p>
                                            <p>Publicly available sources (e.g., Social Media)</p>
                                            <p>Government sources and records</p>
                                        </td>
                                        <td colspan="1" rowspan="1">
                                            <p>To provide the Proper platform and related recruiting services</p>
                                            <p>Business Operations</p>
                                            <p>Marketing</p>
                                            <p>Cybersecurity, fraud prevention and other security purposes</p>
                                        </td>
                                        <td colspan="1" rowspan="1">
                                            <p>Service Providers</p>
                                            <p>Government entities</p>
                                            <p>Third parties pursuant to lawful process</p>
                                            <p>Other Proper members and service customers</p>
                                            <p>Third party advertisers and analytics providers</p>
                                            <p>Affiliates and other business partners</p>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <p>The Right to Opt-out of the Sale of Your Personal Data</p>
                            <p>We do not &ldquo;sell&rdquo; your personal information in the traditional sense. As discussed above, we may
                                share your information with our business partners and affiliates, but such sharing does not occur based on
                                the exchange of material consideration.</p>
                            <p>To make such a request, send an email with the subject heading &ldquo;California Privacy Rights&rdquo; to
                                info&#64;fairbridgeinns.com or mail us at:</p>
                            <p>FairBridge Hospitality Systems Inc<br />
                                4101 Dublin Blvd, F408<br />
                                Dublin, CA 94568</p>
                            <p>Attn: Data Privacy Department</p>
                            <p>In your request, please attest to the fact that you are a California resident and provide a current
                                California address for our response. Please be aware that not all information sharing is covered by these
                                California privacy rights requirements, and only information on covered sharing will be included in our
                                response. This request may be made no more than once per calendar year.</p>
                        </ng-template>
                    </div>
                </div>
            </div>
            <div ngbAccordionItem>
                <h2 ngbAccordionHeader>
                    <button ngbAccordionButton>CHANGES TO DATA PRACTICES AND PRIVACY POLICY</button>
                </h2>
                <div ngbAccordionCollapse>
                    <div ngbAccordionBody>
                        <ng-template>
                            <p>We may change our Data Practices and Privacy Policy from time to time. If we make changes, we will notify you
                                by posting those changes on our website and other places we deem appropriate. Please review our Data
                                Practices and Privacy Policy Statement frequently so that you are aware of our current practices.</p>
                        </ng-template>
                    </div>
                </div>
            </div>
            <div ngbAccordionItem>
                <h2 ngbAccordionHeader>
                    <button ngbAccordionButton>CONTACT US</button>
                </h2>
                <div ngbAccordionCollapse>
                    <div ngbAccordionBody>
                        <ng-template>
                            <p>FairCloud Hospitality Systems Inc<br />
                                4101 Dublin Blvd, #F408<br />
                                Dublin, CA 94568<br />
                                Attn: Data Privacy Department<br />
                                privacy&#64;fairbridgeinns.com</p>
                        </ng-template>
                    </div>
                </div>
            </div>
            <div ngbAccordionItem>
                <h2 ngbAccordionHeader>
                    <button ngbAccordionButton>AUTHENTICATION COOKIES</button>
                </h2>
                <div ngbAccordionCollapse>
                    <div ngbAccordionBody>
                        <ng-template>
                            <p>When you log in to your account, we use a secure cookie to store a session or login token. This cookie is essential for maintaining your login status and cannot be disabled without affecting your ability to use the site. These cookies do not track your behavior across other websites and are only used for authentication purposes on our platform.</p>
                        </ng-template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>